import { render } from "./YouthExchangeExperiences.vue?vue&type=template&id=b11a5e8e"
import script from "./YouthExchangeExperiences.vue?vue&type=script&lang=js"
export * from "./YouthExchangeExperiences.vue?vue&type=script&lang=js"
script.render = render

export default script